import { useParams } from "react-router-dom";
import { ExternalProviderPortalContainer } from "../../academy-context/primary/external-provider/external-provider-portal.container";
import { Card, CardContent, CardHeader, CardTitle } from "@components/ui/card";
import { AlertTriangle } from "lucide-react";

const InvalidTokenError = () => (
  <Card className="mt-8 border-red-200 bg-red-50">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-red-700">
        <AlertTriangle className="size-5" />
        Lien invalide
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-red-600">Le lien d'acces est manquant ou invalide.</p>
      <p className="mt-2 text-sm text-red-500">Veuillez verifier le lien recu par email ou contacter l'administrateur.</p>
    </CardContent>
  </Card>
);

export const ExternalProviderPortalPage = () => {
  const { accessToken } = useParams<{ accessToken: string }>();

  if (!accessToken) {
    return <InvalidTokenError />;
  }

  return <ExternalProviderPortalContainer accessToken={accessToken} />;
};
